import React, { Component } from 'react';
import Button from "../reusable/components/Button.jsx";
import Input from "../reusable/components/Input";
import logourl from '@deere/ux.brand-foundations/logos/jd-logo-green-xl@1x.png';
import { Card } from '@deere/ux.uxframe-react';
import baseurl from '../api-properties';
import { isMobile } from 'react-device-detect';
import {getAuthToken, setAuthToken} from "../reusable/basic-auth-creds";

if (isMobile) {
  import('../mobileindex.css').then(() => {});
} else {
  import('../company/components/scss/index.css').then(() => {});
}
class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayReGeneratePassword: false,
      formValue: {
        prosSuppId: 0,
        proSuppEmail: "",
        proSuppPwd: ""
      },
      formErrors: {
        validationMsg: "",
        email: "",
        password: "",
        showError: false
      }
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.reGeneratePassword = this.reGeneratePassword.bind(this);
    this.validateResendEmail = this.validateResendEmail.bind(this);
  }

  handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState(
      prevState => ({
        formValue: {
          ...prevState.formValue,
          [name]: value
        }
      }),
    );
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
    this.formError = this.validateOnSubmit();
    setAuthToken(this.state.formValue.proSuppEmail, this.state.formValue.proSuppPwd);
    if (this.formError) {
      this.validateEmail(e, true);
    }
  }

  validateResendEmail = (e) => {
    e.preventDefault();
    this.formError = this.validateOnSubmit();
    if (this.formError) {
      this.reGeneratePassword(e);
    }
  }

  validateEmail(e, doLogin) {
    e.preventDefault();
    let userData = { proSuppEmail: this.state.formValue.proSuppEmail };
    fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/validateEmail", {
      method: "POST",
      body: JSON.stringify(userData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization" : "Basic " + getAuthToken(),
      }
    }).then(response => {
      this.state.formErrors.validationMsg = "";
      if (response.status === 204 || response.status === 401 || response.status === 403) {
        this.state.formErrors.showError = true;
//        fieldErrors.validationMsg = "Please enter valid email ID.";
        this.state.formErrors.validationMsg = "Authentication failed. Please try again. Or your password has expired. To generate new password, please enter your email address and click on re-generate password link.";
        this.setState({ formErrors: this.state.formErrors });
        this.setState({ displayReGeneratePassword: true });
      } else return response;
    }).then((response) => {
      if (doLogin) {
        this.validateSupplier(e);
      } else {
        this.reGeneratePassword(e);
      }
    }).catch(error => {
      this.state.formErrors.showError = true;
      this.state.formErrors.validationMsg = "An unhandled error has occurred.";
      this.setState({ formErrors: this.state.formErrors });
      console.log(error);
    });
  }

  validateSupplier(e) {
    e.preventDefault();
    this.state.formErrors.validationMsg = "";
    let userData = this.state.formValue;
    fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/validateSupplier", {
      method: "POST",
      body: JSON.stringify(userData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization" : "Basic " + getAuthToken(),
      }
    }).then(response => {
      if (response.status === 401 || response.status === 403) {
        let fieldErrors = this.state.formErrors;
        fieldErrors.showError = true;
        fieldErrors.validationMsg = "Authentication failed. Please try again. Or your password has expired. To generate new password, please enter your email address and click on re-generate password link.";
        this.setState({ formErrors: fieldErrors });
        this.setState({ displayReGeneratePassword: true });
      } else return response.json();
    }).then(data => {
      if (data !== undefined && data != null) {
        this.setState({ formValue: data });
        let prosNumber = this.state.formValue.prosNumber;
        document.location.href = "/supplier-summary/" + prosNumber;
      }
    }).catch(error => {
      console.log(error);
    });
  }

  reGeneratePassword(e) {
    e.preventDefault();
    this.state.formErrors.validationMsg = "";
    let userData = { proSuppEmail: this.state.formValue.proSuppEmail };
    fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/reGeneratePassword", {
      method: "POST",
      body: JSON.stringify(userData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }).then(response => {
      if (response.status === 204 || response.status === 200) {
        let fieldErrors = this.state.formErrors;
        fieldErrors.showError = true;
        fieldErrors.validationMsg = "Your new password has been sent to your '" + this.state.formValue.proSuppEmail + "' email address.";
        this.setState({ formErrors: fieldErrors });
        this.setState({ displayReGeneratePassword: false });
      } else {
        let fieldErrors = this.state.formErrors;
        fieldErrors.showError = true;
        fieldErrors.validationMsg = "Error seems to have prevented password regeneration.";
        this.setState({ formErrors: fieldErrors });
      }
    }).catch(error => {
      let fieldErrors = this.state.formErrors;
      fieldErrors.showError = true;
      fieldErrors.validationMsg = "Error seems to have prevented password regeneration.";
      this.setState({ formErrors: fieldErrors });
      console.log(error);
    });
  }

  validateOnSubmit = () => {
    let fieldErrors = this.state.formErrors;
    let error = this.validationMessage();
    if (error) {
      fieldErrors.showError = true;
      this.setState({ formErrors: fieldErrors });
    } else {
      fieldErrors.showError = false;
      this.setState({ formErrors: fieldErrors });
    }
    return !error;
  };

  validationMessage = () => {
    let fieldErrors = this.state.formErrors;
    let isValid = "";

    if (this.state.formValue.proSuppEmail.length <= 0) {
      fieldErrors.email = "Email is required field.";
      isValid = true;
    } else fieldErrors.email = "";

    if (this.state.formValue.proSuppPwd.length <= 0) {
      fieldErrors.password = "Password is required field.";
      isValid = true;
    } else fieldErrors.password = "";

    return isValid;
  };

  render() {
    return (
      <form>
        <div>
          <div className="container-fluid bg-light">
            <br /><div style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={logourl} alt="" style={{ alignSelf: 'center', width: 280, height: 55 }} />
            </div><br />
            <div style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center' }}>
              <Card style={{ width: 550, height: 500 }}>
                <div className="row">
                  <div className="col-sm-24" style={columnHeaderStyle}>
                    <h2>Prospective Supplier Application </h2>
                    <span className="error">{this.state.formErrors.validationMsg}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-24" style={columnDataStyle}>
                    <Input
                      type={"text"}
                      name={"proSuppEmail"}
                      title={""}
                      style={{ width: 300 }}
                      placeholder={"Email Address"}
                      value={this.state.formValue.proSuppEmail}
                      onChange={this.handleInput}
                    /><span className="error">{this.state.formErrors.email}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-24" style={columnDataStyle}>
                    <Input
                      type={"password"}
                      name={"proSuppPwd"}
                      title={""}
                      style={{ width: 300 }}
                      placeholder={"Password provided in email"}
                      value={this.state.formValue.proSuppPwd}
                      onChange={this.handleInput}
                    /><span className="error">{this.state.formErrors.password}</span>
                  </div>
                </div>
                {this.state.displayReGeneratePassword === true ?
                  <div className="row">
                    <div className="col-sm-24">
                      <p style={columnLabelStyle}><a href="#" onClick={this.validateResendEmail}>Re-Generate Password</a></p>
                    </div>
                  </div>
                  : ""
                }
                <div className="row">
                  <div className="col-sm-24">
                    <p className="component-title" style={columnLabelStyle}>Reference the confirmation email you recieved for your Log in information.</p>
                    <p className="component-title" style={columnLabelStyle}>If you do not receive the confirmation message within a few minutes,please check your Junk or Spam folder.</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-24" style={columnButtonStyle}>
                    <Button style={{ width: 300 }} type={"warning"} action={this.handleFormSubmit} title={"Sign In"} />{" "}
                  </div>
                </div>
              </Card>
            </div>
            <br/><br/><br/><br/><br/><br/>
          </div>
        </div>
      </form>
    );
  }
}

const columnHeaderStyle = {
  alignSelf: 'center',
  padding: "30px 0px 30px 60px"
};

const columnDataStyle = {
  alignSelf: 'center',
  padding: "0px 0px 0px 120px"
};

const columnLabelStyle = {
  alignSelf: 'center', display: 'flex', justifyContent: 'center',
  padding: "0px 130px 0px 120px"
};

const columnButtonStyle = {
  alignSelf: 'center',
  padding: "0px 130px 0px 120px"
};

export default LoginScreen;